/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);
    $(window).on('load', getAudioContext);

    function setup() {
        //initTarteAuCitron();
        initQuestions();
        $('.startpage .btn-show').click(showHideAllGifts);
        $('a, .is-anchor').click(goToAnchor);
        $(window).on('click', startVideoSound);
    }

    function getAudioContext() {
        var context = new AudioContext();
        if(context.state === 'running') {
            $('.header video').prop('muted', false);
            if($(window).width() >= 760) {
                $('.header video.desktop').trigger('play');
            }else {
                $('.header video.mobile').trigger('play');
            }
        }
    }

    function startVideoSound() {
        $('.header video').prop('muted', false);
    }

    function initQuestions() {
        if($('.questions').length !== 0) {
            $('input[name="answerchoice"]').on('change', function() {
                if($(this).parent().parent().hasClass('special')) {
                    $('.valid').addClass('show');
                    let currentQuest = $('.questanwser.current');
                    let numQuest = $('.numtheme span').text();
                    if(currentQuest.next().hasClass('questanwser')) {
                        setTimeout(function() {
                            $('.questanwser').removeClass('current');
                            currentQuest.next().addClass('current');
                            $('.numtheme span').text(parseInt(numQuest) + 1);
                        }, 1501);
                    }else {
                        if($(this).val() === 'Thierry Lhermitte, le vrai gamer') {
                            $('.videospecial').addClass('show');
                            $('.videospecial video').trigger('play');
                        }else {
                            $('.sendEmail').submit();
                        }
                    }
                }else {
                    $('.error').addClass('show');
                }
                setTimeout(function() {
                    $('.valid').removeClass('show');
                    $('.error').removeClass('show');
                }, 1500);
            })
        }
    }

    function initTarteAuCitron() {
        tarteaucitron.init({
            "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
            "highPrivacy": false, /* désactiver le consentement implicite (en naviguant) ? */
            "orientation": "bottom", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
            "adblocker": false, /* Afficher un message si un adblocker est détecté */
            "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
            "cookieslist": true, /* Afficher la liste des cookies installés ? */
            "removeCredit": true, /* supprimer le lien vers la source ? */
            "useExternalCss": true
        });

        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
    }

    function showHideAllGifts() {
        if($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.gifts').removeClass('showAll');
        }else {
            $(this).addClass('open');
            $('.gifts').addClass('showAll');
        }
    }

    function videoEnded() {
        $('.sendEmail').submit();
    }

    // Animation pour aller aux ancres
    function goToAnchor(e) {
        var url = $(this).attr('href');
        if(url.indexOf('#') !== -1 && url !== '#') {
            e.preventDefault();
            var id = url.split('#')[1];
            var offset = $('#'+id).offset().top - 50;
            $('html, body').animate({scrollTop: offset}, 1200);
        }
    }

